import { GlobalLayout, CustomRouteLayout } from "./components";

export const Layouts = {
  Global: GlobalLayout,
  CustomRoute: CustomRouteLayout,
};
